// LQC-2676 - which holiday calendar a trade settles against, by currency.
//
// The API requires a calendar on every option and swap message and validates it against
// the Calendar table, but no endpoint serves the list (LQC-2673 / LQC-2675 would add
// one). These are FpML business-centre codes, seeded from the published scheme and
// stable, so mapping them here is safe until an endpoint exists.
// Source: LQDatabase/LQScripts/02_PostDbDeployScripts/0017 - INSERT Calendar records.sql

export const DEFAULT_CALENDAR_CODE = "GBLO";

const CALENDAR_BY_CURRENCY: Record<string, string> = {
  AUD: "AUSY",
  CAD: "CATO",
  CHF: "CHZU",
  EUR: "EUTA", // TARGET, the euro business centre - not a city
  GBP: "GBLO",
  JPY: "JPTO",
  NZD: "NZWE",
  SEK: "SEST",
  USD: "USNY",
};

// Falls back rather than returning empty: the field is required, and a wrong-but-valid
// calendar is a better failure than a 400 the user cannot act on.
export function returnCalendarForCurrency(
  currency: string | undefined | null,
): string {
  if (!currency) return DEFAULT_CALENDAR_CODE;
  return (
    CALENDAR_BY_CURRENCY[currency.trim().toUpperCase()] ?? DEFAULT_CALENDAR_CODE
  );
}

// The currencies we can resolve a calendar for. Also the payment-currency choices a
// ticket offers, so a currency we cannot calendar cannot be picked.
export const CALENDAR_CURRENCIES: string[] = Object.keys(CALENDAR_BY_CURRENCY);

export function isCurrencyMappedToCalendar(
  currency: string | undefined | null,
): boolean {
  if (!currency) return false;
  return currency.trim().toUpperCase() in CALENDAR_BY_CURRENCY;
}
